import * as React from 'react';
import Tooltip from 'antd/lib/tooltip';
import Icon from 'antd/lib/icon';

function isCustomer(activeTab) {
  return (
    activeTab === 'CUSTOMER' ||
    activeTab === 'SUPPLIER' ||
    activeTab === 'SHIPPER'
  );
}

const internalSpocTooltip = (orgType: string) => {
  const text = isCustomer(orgType) ?  'Shipments ' : 'Inquiries ';
  return <Tooltip
    placement="right"
    title={`${text} 
      added by this organization for you will be visible to the POC team.
      In case no POC team is added, ${text} will be visible to all the users of the
      organization.`}>
    Internal POC
    {renderIcon()}
  </Tooltip>;
};

const renderIcon = () => {
  return <Icon
    type="info-circle"
    theme="filled"
    style={{
      color: '#333333',
      marginLeft: '5px',
    }}
  />;
};

const modeOfFreightTooltip = () => {
  return <React.Fragment>
    Mode of Freight Service
    <Tooltip
      title="Please enable/disable the mode for FF based on your requirements.">
      {renderIcon()}
    </Tooltip>
  </React.Fragment>;
};

const renderGroups = () => {
  return <React.Fragment>
    Group
    <Tooltip
      title="Create groups basis regions, tradelanes etc and map it to your FFs.
      This helps you filter FFs basis tagged group while sending inquiry">
      {renderIcon()}
    </Tooltip>
  </React.Fragment>;
};

const renderShipperGroups = () => {
  return <React.Fragment>
    Group
    <Tooltip
      title="Create groups (tiers) basis monthly container volume,
      credit days etc and map it to your Shippers.
      This helps you assign margins to shippers basis tagged group.">
      {renderIcon()}
    </Tooltip>
  </React.Fragment>;
};

const renderVendorRating = () => {
  return (
    <React.Fragment>
      Ranking
      <Tooltip 
      title="This enables shippers to assess vendors beyond just bid value, 
      ensuring they select the best overall service for their bookings.">
        {renderIcon()}
      </Tooltip>
    </React.Fragment>
  );
};

const isFForgShipperTab = (type, activeTab) => {
  return type === 'FF' && activeTab === 'SHIPPER';
};

const isShipperOrgFFTab = (type, activeTab) => {
  return type === 'SHIPPER' && activeTab === 'FF';
};

export {
  renderIcon,
  renderGroups,
  internalSpocTooltip,
  modeOfFreightTooltip,
  renderShipperGroups,
  isFForgShipperTab,
  isShipperOrgFFTab,
  isCustomer,
  renderVendorRating
};
